<div class="box-section box-section--{{ type }}">
  @if (title) {
    <h2 class="box-section__title">{{ title }}</h2>
  }
  <div class="box-section__main {{ alignItems ? 'box-section__main--' + alignItems : '' }}">
    @if (icon) {
      <app-icon class="box-section__icon" [icon]="icon" [width]="20"></app-icon>
    }
    <div class="box-section__content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
